import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
// A pause suspends attendance, not access to one's own pause and billing data.
export const pauseSelfServicePath = (pathname) => /^\/Home\/(?:course\/(?:pauseCourse|cancellationCoursePackage)|profile(?:\/(?:personalInfo|packages|courses|openBill|receipt))?|faq)(?:\/|$)/i.test(pathname);
const PrivateRoutes = () => {
  const { pathname } = useLocation();
  if (localStorage.getItem("session_user_status") !== "Active") return <Navigate to="/" replace />;
  if (Number(localStorage.getItem("is_pause_student")) === 1 && !pauseSelfServicePath(pathname)) return <Navigate to="/Home/course/pauseCourse" replace />;
  return <Outlet />;
};
export default PrivateRoutes;
